.River {
  display: grid;
  gap: var(--brand-River-spacing-inner);
  grid-auto-rows: min-content;
  padding-inline: var(--brand-River-spacing-outerInline);
  padding-block: var(--brand-River-spacing-outerBlock);
  container-type: inline-size;
}

.River--variant-gridline {
  position: relative;
  padding-inline: var(--brand-River-variant-gridline-spacing-outerInline);
  padding-block: var(--brand-River-variant-gridline-spacing-outerBlock);
  gap: var(--base-size-32);
}

@media screen and (min-width: 48rem) {
  .River--variant-gridline {
    gap: var(--base-size-28);
  }
}

@media screen and (min-width: 80rem) {
  .River--variant-gridline {
    border-inline: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
  }
}

.River--align-center {
  text-align: center;
}

.River__content {
  order: 2;
}

.River__visual :is(img, picture) {
  display: block;
}

.River__visual--fill-media img,
.River__visual--fill-media picture,
.River__visual--fill-media video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.River__visual--rounded {
  overflow: hidden;
  border-radius: var(--brand-borderRadius-large);
}

.River__visual--has-shadow {
  box-shadow: var(--brand-River-visual-shadow);
}

.River--variant-gridline .River__visual--has-background {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--brand-color-canvas-subtle);
  padding: var(--brand-River-variant-gridline-visual-padding);
  border-radius: 0;
  margin-inline: calc(-1 * var(--brand-River-variant-gridline-spacing-outerInline));
}

.River--variant-gridline .River__visual--has-background img,
.River--variant-gridline .River__visual--has-background picture,
.River--variant-gridline .River__visual--has-background video {
  max-width: 100%;
  height: auto;
  width: auto;
  border-radius: var(--brand-borderRadius-large);
}

@media screen and (max-width: 47.99rem) {
  .River--variant-gridline .River__visual--has-background {
    align-items: flex-end;
    justify-content: flex-end;
    padding-block-end: 0;
    padding-inline-end: 0;
  }

  .River--variant-gridline .River__visual--has-background img,
  .River--variant-gridline .River__visual--has-background picture,
  .River--variant-gridline .River__visual--has-background video {
    border-end-start-radius: 0;
    border-end-end-radius: 0;
    border-start-end-radius: 0;
  }
}

@media screen and (min-width: 48rem) and (max-width: 63.24rem) {
  .River {
    max-width: 618px;
    margin-inline: auto;
  }

  .River--variant-gridline {
    border-inline: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
  }

  .River--variant-gridline .River__visual--has-background {
    align-items: flex-end;
    padding-block-end: 0;
  }

  .River--variant-gridline .River__visual--has-background img,
  .River--variant-gridline .River__visual--has-background picture,
  .River--variant-gridline .River__visual--has-background video {
    border-end-start-radius: 0;
    border-end-end-radius: 0;
  }
}

.River__heading {
  margin-bottom: var(--brand-River-heading-margin);
}

.River__call-to-action {
  margin-top: var(--base-size-24);
}

.River__text strong,
.River__text b {
  font-weight: var(--base-text-weight-normal);
  color: var(--brand-color-text-default);
}

.River__heading code,
.River__text code {
  font-size: inherit;
  font-family: var(--brand-fontStack-monospace) !important;
  background-color: var(--brand-color-canvas-subtle);
  padding: 0 var(--base-size-4) var(--base-size-2);
  margin-inline: var(--base-size-2);
  border: var(--brand-borderWidth-thin) solid var(--brand-color-border-default);
  border-radius: var(--brand-borderRadius-small);
  box-shadow: var(--brand-borderWidth-thin) var(--brand-borderWidth-thin) 0 0 var(--brand-color-border-default);
}

.River__text code {
  padding: var(--base-size-2) var(--base-size-4) 0;
}

.River__heading-inner:has(code) {
  line-height: calc(1lh * 1.8);
}

@media screen and (min-width: 64rem) {
  .River__heading-inner:has(code) {
    line-height: calc(1lh * 2.1);
  }
}

.River__text:has(code) {
  line-height: calc(1lh * 1.1);
}

.River__leadingComponent :is(img, picture),
.River__trailingComponent :is(img, picture) {
  display: block;
}

.River__trailingComponent {
  margin-block-start: var(--brand-River-spacing-inner);
}

.River__trailingComponent--divider {
  padding-block-start: var(--brand-River-spacing-inner);
  border-top: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
}

.River__label {
  margin-block-end: var(--brand-River-label-margin);
}

.River--variant-gridline.River--align-start .River__visual {
  order: 1;
}

.River--variant-gridline.River--align-start .River__content {
  order: 2;
}

.River--variant-gridline.River--align-end .River__content {
  order: 1;
}

.River--variant-gridline.River--align-end .River__visual {
  order: 2;
}

@media screen and (max-width: 63.24rem) {
  .River--variant-gridline.River--align-start .River__visual--has-background {
    margin-block-start: calc(-1 * var(--brand-River-variant-gridline-spacing-outerBlock));
  }

  .River--variant-gridline.River--align-end .River__visual--has-background {
    margin-block-end: calc(-1 * var(--brand-River-variant-gridline-spacing-outerBlock));
  }

  .River--variant-gridline.River--align-center .River__visual--has-background {
    margin-block-start: calc(-1 * var(--brand-River-variant-gridline-spacing-outerBlock));
  }
}

/* Large breakpoint and up */
@media screen and (min-width: 63.25rem) {
  .River {
    grid-template-rows: unset;
  }

  .River--variant-gridline .River__visual--has-background {
    margin: 0;
  }

  .River__content {
    order: unset;
  }

  .River--50-50 {
    grid-template-columns: [content] 1fr [visual] 1fr;
  }

  .River--60-40 {
    grid-template-columns: [content] 4fr [visual] 6fr;
  }

  .River--align-start {
    grid-template-areas: 'content visual';
  }

  .River--align-end {
    grid-template-areas: 'visual content';
  }

  .River--align-end.River--60-40 {
    grid-template-columns: [visual] 6fr [content] 4fr;
  }

  .River--variant-gridline.River--align-start.River--50-50:not(:has(.River__visual--has-background)) .River__visual {
    margin-inline-start: calc(var(--base-size-80) + var(--base-size-8));
  }

  .River--variant-gridline.River--align-end.River--50-50:not(:has(.River__visual--has-background)) .River__visual {
    margin-inline-end: calc(var(--base-size-80) + var(--base-size-8));
  }

  .River__content {
    display: grid;
    align-content: center;
    grid-area: content;
  }

  .River--50-50:not(.River--variant-gridline) .River__body-text,
  .River--50-50:not(.River--variant-gridline) .River__heading {
    max-width: 400px;
  }

  .River--align-start:not(.River--variant-gridline) .River__content {
    padding-inline-end: var(--base-size-128);
  }

  .River--align-end:not(.River--variant-gridline) .River__content {
    padding-inline-start: var(--base-size-128);
  }

  .River__content--align-block-end {
    align-content: end;
  }

  .River__visual {
    grid-area: visual;
  }

  .River--align-center {
    grid-auto-rows: min-content;
    grid-template-columns: unset;
  }

  .River--align-center .River__content,
  .River--align-center .River__visual {
    grid-area: unset;
    justify-self: center;
  }

  .River--align-center .River__body-text {
    max-width: 600px;
    justify-self: center;
  }

  .River--align-center .River__visual {
    margin-bottom: var(--brand-River-spacing-inner);
  }

  .River--align-center .River__content {
    margin-top: var(--brand-River-spacing-inner);
  }

  .River--variant-gridline:not(.River--align-center):has(.River__visual--has-background) {
    padding: 0;
    gap: 0;
  }

  .River--variant-gridline.River--50-50:not(.River--align-center):has(.River__visual--has-background) {
    grid-template-columns: 1fr 1fr;
  }

  .River--variant-gridline.River--60-40:not(.River--align-center):has(.River__visual--has-background) {
    grid-template-columns: 560fr 676fr;
  }

  .River--variant-gridline.River--align-end.River--60-40:has(.River__visual--has-background) {
    grid-template-columns: 676fr 560fr;
  }

  .River--variant-gridline.River--align-start:has(.River__visual--has-background) .River__content {
    padding-inline-start: var(--base-size-64);
    padding-inline-end: var(--brand-River-spacing-inner);
    padding-block: var(--brand-River-variant-gridline-spacing-outerBlock);
  }

  .River--variant-gridline.River--50-50.River--align-start:has(.River__visual--has-background) .River__content {
    padding-inline-end: calc(var(--base-size-80) + var(--base-size-32));
  }

  .River--variant-gridline.River--60-40.River--align-start:has(.River__visual--has-background) .River__content {
    padding-inline-end: var(--base-size-128);
  }

  .River--variant-gridline.River--align-end:has(.River__visual--has-background) .River__content {
    padding-inline-start: var(--brand-River-spacing-inner);
    padding-inline-end: var(--base-size-64);
    padding-block: var(--brand-River-variant-gridline-spacing-outerBlock);
  }

  .River--variant-gridline.River--50-50.River--align-end:has(.River__visual--has-background) .River__content {
    padding-inline-start: calc(var(--base-size-80) + var(--base-size-32));
  }

  .River--variant-gridline.River--60-40.River--align-end:has(.River__visual--has-background) .River__content {
    padding-inline-start: var(--base-size-128);
  }

  .River--variant-gridline.River--align-start:not(:has(.River__visual--has-background)) .River__content {
    padding-inline-end: var(--brand-River-spacing-inner);
  }

  .River--variant-gridline.River--align-end:not(:has(.River__visual--has-background)) .River__content {
    padding-inline-start: var(--brand-River-spacing-inner);
  }

  .River--variant-gridline.River--50-50:not(.River--align-center) .River__visual--has-background {
    margin-inline-start: 0;
    margin-inline-end: 0;
  }

  .River--variant-gridline.River--align-center:has(.River__visual--has-background) {
    padding: 0;
  }

  .River--variant-gridline.River--align-center .River__visual--has-background {
    width: 100%;
    margin: 0;
  }

  .River--variant-gridline.River--align-center .River__visual {
    margin-bottom: 0;
  }

  .River--variant-gridline.River--align-center {
    gap: 0;
  }

  .River--variant-gridline.River--align-center .River__content {
    margin-top: 0;
    margin-bottom: var(--base-size-64);
  }

  .River--variant-gridline.River--align-center:has(.River__visual--has-background) .River__content {
    padding-inline: var(--brand-River-variant-gridline-spacing-outerInline);
    padding-block-start: var(--brand-River-variant-gridline-spacing-outerBlock);
  }
}

/* Explicit visual media layouts override the responsive default without changing it. */
.River--variant-gridline .River__visual.River__visual--position-center {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--brand-River-variant-gridline-visual-padding);
  border-radius: 0;
}

.River--variant-gridline .River__visual.River__visual--position-block-end {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: var(--brand-River-variant-gridline-visual-padding);
  padding-block-end: 0;
  border-radius: 0;
}

.River--variant-gridline .River__visual.River__visual--position-block-end-inline-start {
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  padding: var(--brand-River-variant-gridline-visual-padding);
  padding-block-end: 0;
  padding-inline-start: 0;
  border-radius: 0;
}

.River--variant-gridline .River__visual.River__visual--position-block-end-inline-end {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding: var(--brand-River-variant-gridline-visual-padding);
  padding-block-end: 0;
  padding-inline-end: 0;
  border-radius: 0;
}

.River--variant-gridline .River__visual.River__visual--padding-all {
  padding: var(--brand-River-variant-gridline-visual-padding);
}

.River--variant-gridline .River__visual.River__visual--padding-none {
  padding: 0;
  border-radius: 0;
}

.River--variant-gridline
  .River__visual:is(
    .River__visual--position-center,
    .River__visual--position-block-end,
    .River__visual--position-block-end-inline-start,
    .River__visual--position-block-end-inline-end
  )
  :is(img, picture, video, [data-video-player-container]) {
  max-width: 100%;
  width: auto;
  height: auto;
  border-radius: 0;
}

.River--variant-gridline
  .River__visual.River__visual--padding-all
  :is(img, picture, video, [data-video-player-container]) {
  border-radius: 0;
}

.River--variant-gridline
  .River__visual.River__visual--rounded.River__visual--position-center
  :is(img, picture, video, [data-video-player-container]) {
  border-radius: var(--brand-borderRadius-large);
}

.River--variant-gridline
  .River__visual.River__visual--rounded.River__visual--position-block-end
  :is(img, picture, video, [data-video-player-container]) {
  border-radius: var(--brand-borderRadius-large) var(--brand-borderRadius-large) 0 0;
}

.River--variant-gridline
  .River__visual.River__visual--rounded.River__visual--position-block-end-inline-start
  :is(img, picture, video, [data-video-player-container]) {
  border-radius: 0;
  border-start-end-radius: var(--brand-borderRadius-large);
}

.River--variant-gridline
  .River__visual.River__visual--rounded.River__visual--position-block-end-inline-end
  :is(img, picture, video, [data-video-player-container]) {
  border-radius: 0;
  border-start-start-radius: var(--brand-borderRadius-large);
}

.River--variant-gridline
  .River__visual.River__visual--rounded.River__visual--padding-all
  :is(img, picture, video, [data-video-player-container]) {
  border-radius: var(--brand-borderRadius-large);
}

.River--variant-gridline
  .River__visual.River__visual--fill-media.River__visual--padding-none
  :is(img, picture, video, [data-video-player-container]) {
  width: 100%;
  max-width: none;
  height: 100%;
  object-fit: cover;
}

.River--variant-gridline
  .River__visual.River__visual--padding-none
  :is(img, picture, video, [data-video-player-container]),
.River--variant-gridline
  .River__visual.River__visual--rounded.River__visual--padding-none
  :is(img, picture, video, [data-video-player-container]) {
  border-radius: 0;
}

.RiverBreakout {
  display: flex;
  flex-direction: column;
  gap: var(--brand-RiverBreakout-spacing-inner);
  padding-block-end: var(--brand-River-spacing-outerBlock);
  padding-block-start: var(--brand-River-spacing-outerBlock);
}

.RiverBreakout .River__text {
  max-width: 37.5rem; /* 600px */
  color: var(--brand-color-text-default);
  font-size: var(--brand-text-size-500);
  font-weight: var(--brand-heading-weight-500);
  letter-spacing: var(--brand-heading-letterSpacing-500);
  line-height: var(--brand-text-lineHeight-500);
}

.RiverBreakout--muted .River__text {
  color: var(--brand-color-text-muted);
}

.RiverBreakout .River__text em,
.RiverBreakout .River__text b {
  color: var(--brand-color-text-default);
  font-style: normal;
  font-weight: inherit;
}

.RiverBreakout__hiddenHeading {
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
  height: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.RiverBreakout .River__call-to-action {
  padding-block-start: var(--base-size-12);
}

@media screen and (min-width: 48rem) {
  .RiverBreakout .River__content {
    display: grid;
    gap: var(--brand-River-spacing-inner);
    row-gap: var(--brand-River-spacing-innerY);
    grid-template-areas:
      'text trailingComponent'
      'cta trailingComponent';
    grid-template-columns: 5fr 3fr;
    grid-auto-rows: auto 1fr;
  }

  .RiverBreakout .River__text {
    grid-area: text;
  }

  .RiverBreakout .River__call-to-action {
    grid-area: cta;
    margin-block: 0;
  }

  .RiverBreakout .River__trailingComponent {
    grid-area: trailingComponent;
    justify-self: flex-end;
    margin-block-start: 0;
  }
}

.RiverBreakout--variant-gridline {
  position: relative;
  padding-inline: var(--brand-RiverBreakout-variant-gridline-spacing-outerInline);
  padding-block-start: var(--brand-RiverBreakout-variant-gridline-spacing-outerBlock);
  padding-block-end: 0;
  gap: 0;
}

@media screen and (max-width: 63.24rem) {
  .RiverBreakout--variant-gridline {
    width: 100%;
    max-width: 38.625rem;
    margin-inline: auto;
  }
}

@media screen and (min-width: 618px) {
  .RiverBreakout--variant-gridline {
    border-inline: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
  }
}

@media screen and (min-width: 63.25rem) {
  .RiverBreakout--variant-gridline {
    border-inline: none;
  }
}

@media screen and (min-width: 1300px) {
  .RiverBreakout--variant-gridline {
    border-inline: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
  }
}

.RiverBreakout--variant-gridline .River__visual {
  overflow: hidden;
}

.RiverBreakout--variant-gridline .River__visual--rounded {
  border-radius: var(--brand-borderRadius-large);
}

.RiverBreakout--variant-gridline .River__content {
  padding-block-start: var(--brand-RiverBreakout-variant-gridline-spacing-outerBlock);
  padding-block-end: var(--brand-RiverBreakout-variant-gridline-spacing-outerBlockEnd);
  gap: var(--brand-RiverBreakout-variant-gridline-spacing-contentGap);
}

.RiverBreakout--variant-gridline .River__call-to-action {
  padding-block-start: var(--base-size-12);
}

.RiverBreakout--variant-gridline .River__trailingComponent--divider {
  padding-block-start: var(--brand-RiverBreakout-variant-gridline-spacing-outerBlock);
  padding-block-end: var(--brand-RiverBreakout-variant-gridline-spacing-outerBlockEnd);
  border-top: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
  margin-inline: calc(-1 * var(--brand-RiverBreakout-variant-gridline-spacing-outerInline));
  padding-inline: var(--brand-RiverBreakout-variant-gridline-spacing-outerInline);
}

/* Reset base RiverBreakout grid for gridline variant until desktop breakpoint */
@media screen and (min-width: 48rem) and (max-width: 63.24rem) {
  .RiverBreakout--variant-gridline .River__content {
    display: flex;
    flex-direction: column;
  }

  .RiverBreakout--variant-gridline .River__trailingComponent {
    margin-block-start: 0;
  }
}

@media screen and (min-width: 63.25rem) {
  .RiverBreakout--variant-gridline:has(.River__trailingComponent--divider) {
    padding-block-end: 0;
  }

  .RiverBreakout--variant-gridline .River__content {
    display: grid;
    grid-template-areas:
      'text trailingComponent'
      'cta trailingComponent';
    grid-template-columns: 1fr var(--brand-RiverBreakout-gridline-trailing-width, 31rem);
    grid-template-rows: auto 1fr;
    gap: var(--brand-RiverBreakout-variant-gridline-spacing-contentGap);
    flex: 1;
    padding-block: 0;
  }

  .RiverBreakout--variant-gridline .River__text {
    grid-area: text;
    padding-block-start: var(--brand-RiverBreakout-variant-gridline-spacing-outerBlock);
  }

  .RiverBreakout--variant-gridline .River__call-to-action {
    grid-area: cta;
    margin-block: 0;
    padding-block-end: var(--brand-RiverBreakout-variant-gridline-spacing-outerBlockEnd);
  }

  .RiverBreakout--variant-gridline .River__trailingComponent {
    grid-area: trailingComponent;
    margin-block-start: 0;
  }

  .RiverBreakout--variant-gridline .River__trailingComponent--divider {
    border-top: none;
    border-left: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
    margin-inline: 0;
    margin-block: 0;
    padding-inline: 0;
    padding-inline-start: var(--brand-RiverBreakout-variant-gridline-spacing-outerInline);
    padding-block: 0;
    padding-block-start: var(--brand-RiverBreakout-variant-gridline-spacing-outerBlock);
    padding-block-end: var(--brand-RiverBreakout-variant-gridline-spacing-outerBlockEnd);
    align-self: stretch;
  }
}
